export const policyConstants = {
    SET_POLICIES: 'POLICY_SET_POLICIES',
    SET_POLICY: 'POLICY_SET_POLICY',
    SET_POLICY_PLOT: 'POLICY_SET_POLICY_PLOT',
};
